/**
 * @fileoverview Highscore Management - ハイスコア管理
 */

import { MinimalErrorTracker } from '../shared/log.js';

import persistenceManager from './persistence-manager.js';

/**
 * ハイスコアエントリを保存
 * @param {Object} entry - ハイスコアエントリ
 * @param {number} entry.score - スコア
 * @returns {Object} 保存されたエントリ
 */
export function saveEntry(entry) {
  const now = Date.now();
  const safeScore = Math.max(0, Number(entry && entry.score) || 0);

  const newEntry = { score: safeScore, createdAt: now };

  // 永続化層から現在のハイスコアを取得
  const currentHighscores = persistenceManager.loadHighscores() || [];
  const updatedHighscores = [...currentHighscores, newEntry];

  // 永続化層に直接保存
  const saved = persistenceManager.saveHighscores(updatedHighscores);

  if (!saved) {
    MinimalErrorTracker.critical('Highscore save failed');
    return null;
  }

  return newEntry;
}

/**
 * 上位ハイスコアを取得
 * @param {number} [limit=10] - 取得する件数
 * @returns {Array} ハイスコアエントリの配列
 */
export function getTop(limit = 10) {
  const highscores = persistenceManager.loadHighscores() || [];
  const normalizedLimit = Math.max(0, Math.min(limit, 20));
  return highscores.slice(0, normalizedLimit);
}

/**
 * 全ハイスコアをクリア
 */
export function clearAllScores() {
  persistenceManager.saveHighscores([]);
}

/**
 * 指定スコアがハイスコアかどうかを判定
 * @param {number} score - 判定するスコア
 * @param {number} [limit=10] - ハイスコア上位何位までを対象とするか
 * @returns {boolean} ハイスコアかどうか
 */
export function isHighScore(score, limit = 10) {
  const numericScore = Math.max(0, Number(score) || 0);
  if (numericScore <= 0) return false;

  const normalizedLimit = Math.max(0, Math.min(limit, 20));
  const currentTop = getTop(normalizedLimit);

  if (currentTop.length < normalizedLimit) return true;

  const last = currentTop[currentTop.length - 1];
  const lastScore = last ? Number(last.score) || 0 : 0;
  return numericScore >= lastScore;
}
